import Image from 'next/image'
import { StrapiImage } from '@components/StrapiMedia'
import { getClassNames } from '@helpers/productWidgetHelper'
import PropertyControlledComponent from '@components/PropertyControlledComponent/PropertyControlledComponent'
import styles from './UspAndRating.module.scss'

interface UspAndRatingType {
  USPs: Array<{
    image?: { data: { attributes: StrapiImage } }
    title?: string
    showInMobile?: boolean
    showAtTopInMobile?: boolean
  }>
}

const UspAndRating = ({ data, noMobilePadding = false }: { data: UspAndRatingType; noMobilePadding?: boolean }) => {
  const topItem = data.USPs.filter(uspItem => uspItem.showAtTopInMobile).at(0) || null
  return (
    <div className={getClassNames([styles.uspMainContainer], { [styles.noMobilePadding]: noMobilePadding })}>
      <div className={styles.uspContainer}>
        <PropertyControlledComponent controllerProperty={!!topItem} fallback={null}>
          <div className={styles.topItem}>
            <p className={styles.topItemTitle}>{topItem?.title}</p>
            {topItem?.image && (
              <Image
                className={styles.topItemImage}
                src={topItem?.image?.data?.attributes?.url}
                alt={topItem?.title || ''}
                height={48}
                width={48}
              />
            )}
          </div>
        </PropertyControlledComponent>
        <div className={styles.uspListContainer}>
          {data.USPs.map(uspItem => (
            <>
              <div
                className={getClassNames([styles.separator, styles.hideInMobile], {
                  [styles.hideInTablet]: !uspItem.showInMobile && !uspItem.showAtTopInMobile,
                })}
              />
              <div
                className={getClassNames([styles.usp], {
                  [styles.hideInTablet]: !uspItem.showInMobile && !uspItem.showAtTopInMobile,
                  [styles.hideInMobile]: !!uspItem.showAtTopInMobile,
                })}>
                {uspItem.image && (
                  <Image
                    className={styles.uspImage}
                    src={uspItem?.image?.data?.attributes?.url}
                    alt={uspItem?.title || ''}
                    height={48}
                    width={48}
                  />
                )}
                <p className={styles.uspTitle}>{uspItem.title}</p>
              </div>
            </>
          ))}
        </div>
      </div>
    </div>
  )
}

export default UspAndRating
